import React from 'react';
import ReactDOM from 'react-dom/client';
import { BrowserRouter } from 'react-router-dom';
import App from './App';
import RootErrorBoundary from './components/RootErrorBoundary';
import {registerServiceWorker} from './utils/pwaReload';
import {installChunkRecovery} from './utils/chunkRecovery';
import { AuthProvider } from './contexts/AuthContext';
import { ThemeProvider } from './contexts/ThemeContext';
import './i18n';
import './styles/index.css';

installChunkRecovery();

const root = ReactDOM.createRoot(
  document.getElementById('root') as HTMLElement
);

root.render(
  <React.StrictMode>
    <RootErrorBoundary>
    <BrowserRouter>
      <ThemeProvider>
        <AuthProvider>
          <App />
        </AuthProvider>
      </ThemeProvider>
    </BrowserRouter>
    </RootErrorBoundary>
  </React.StrictMode>
);

registerServiceWorker();
